import React from 'react';
import { Box } from '@mui/material';

/** Small PRO pill shown next to locked sidebar items for free SERVICE providers. */
export default function ProBadge() {
  return (
    <Box
      component="span"
      sx={{
        bgcolor: '#8B5CF6',
        color: '#fff',
        borderRadius: '6px',
        px: 0.75,
        py: 0.1,
        fontSize: '0.58rem',
        fontWeight: 700,
        letterSpacing: '0.04em',
        lineHeight: 1.6,
        flexShrink: 0,
      }}
    >
      PRO
    </Box>
  );
}
